import { getItemMaker } from "./tools";

const i = getItemMaker("anvil recipes");
export const recipeItems = [
  // SmithingRecipes1
  i("Bandito Pantaloon (Beginner Recipe)"),
  i("Bleached Designer Wode Patch Pants (Beginner Recipe)"),
  i("Copper Band (Beginner Recipe)"),
  i("Double Goopi (Beginner Recipe)"),
  i("Fishing Overalls (Beginner Recipe)"),
  i("Fur Shirt (Beginner Recipe)"),
  i("Goo Galoshes (Beginner Recipe)"),
  i("Iron Boots (Beginner Recipe)"),
  i("Serrated Rex Ring (Beginner Recipe)"),
  i("Steel Band (Beginner Recipe)"),

  // SmithingRecipes2
  i("Defenders Dignity (Novice Recipe)"),
  i("Dootjat Eye (Novice Recipe)"),
  i("Googley Eyes (Novice Recipe)"),
  i("Polished Bludgeon (Novice Recipe)"),
  i("Protectors Pride (Novice Recipe)"),
  i("Skullfish Pendant (Novice Recipe)"),
  i("Star Talent Reset Potion (Novice Recipe)"),
  i("Strung Bludgeon (Novice Recipe)"),

  // SmithingRecipes3
  i("Bucket of Slush (Apprentice Recipe)"),
  i("Dawn Stopwatch (Apprentice Recipe)"),
  i("Midnight Stopwatch (Apprentice Recipe)"),

  // SmithingRecipes4
  i("Bolstered DNA Splicer (Journeyman Recipe)"),
  i("Double Barreled DNA Splicer (Journeyman Recipe)"),
  i("Ergonomic DNA Splicer (Journeyman Recipe)"),
  i("Souped Lab Ring (Journeyman Recipe)"),

  // SmithingRecipes5
  i("Cattle Core Soothsayer Staff (Adept Recipe)"),
  i("Coldseeker Bullet (Adept Recipe)"),
  i("Colossal Food Pouch (Adept Recipe)"),
  i("Colossal Matty Pouch (Adept Recipe)"),
  i("Magma Core Battleskirt (Adept Recipe)"),
  i("Magma Core Headdress (Adept Recipe)"),
  i("Magma Core Lavarunners (Adept Recipe)"),
  i("Magma Core Wavemaille (Adept Recipe)"),
  i("Magma Maul (Adept Recipe)"),
  i("Molten Core Knucklers (Adept Recipe)"),
  i("Sediment Core Grunkler (Adept Recipe)"),

  // SmithingRecipes6
  i("Crown of the Gods (Master Recipe)"),
  i("Demented Emperor Opal (Master Recipe)"),
  i("Divvy Slippers (Master Recipe)"),
  i("Doublestring Godshooter (Master Recipe)"),
  i("Drip of the Gods (Master Recipe)"),
  i("Elegant Spear (Master Recipe)"),
  i("Golden Cake (Master Recipe)"),
  i("Magnifique Godcaster (Master Recipe)"),
  i("Massive Godbreaker (Master Recipe)"),
  i("Mittens of the Gods (Master Recipe)"),
  i("Pentastud Slapper (Master Recipe)"),
  i("Pristine Longbow (Master Recipe)"),
  i("Robe of the Gods (Master Recipe)"),
  i("Shiny Bored Beanie (Master Recipe)"),
  i("Sparky Marble Staff (Master Recipe)"),
  i("Tatters of the Gods (Master Recipe)"),
  i("Zero Point Stopwatch (Master Recipe)"),
];
